import { render } from "./HowItWorksBoxComponent.vue?vue&type=template&id=d63eebb8"
import script from "./HowItWorksBoxComponent.vue?vue&type=script&lang=js"
export * from "./HowItWorksBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__